// Module-level promise cache - prevents duplicate API loads during concurrent requests
let loadPromise = null;

function loadGoogleMaps(apiKey) {
  // Return cached promise if already loading or loaded
  if (loadPromise) {
    return loadPromise;
  }

  // Already loaded by something else
  if (window.google && window.google.maps) {
    return Promise.resolve(window.google.maps);
  }

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=marker`;
    script.async = true;
    script.defer = true;

    script.onload = () => resolve(window.google.maps);
    script.onerror = reject;

    document.head.appendChild(script);
  });

  return loadPromise;
}

export default class GoogleMapService {
  constructor(containerId, options = {}) {
    this.containerId = containerId;
    this.options = {
      mapId: "asdf",
      clickableIcons: false,
      mapTypeControl: false,
      // disable scroll wheel zoom
      scrollwheel: false,
      // disable full screen
      fullscreenControl: false,
      // disable street view
      streetViewControl: false,
      // Add custom styles
      ...options,
    };
  }

  async init(apiKey) {
    const googleMaps = await loadGoogleMaps(apiKey);
    this.map = new googleMaps.Map(
      document.getElementById(this.containerId),
      this.options,
    );

    // Initialize the LatLngBounds object
    this.bounds = new google.maps.LatLngBounds();
  }

  addMarker(lat, lng, label, content = "") {
    const marker = new google.maps.marker.AdvancedMarkerElement({
      position: { lat, lng },
      map: this.map,
      title: label,
      content: content,
    });

    // Extend the bounds to include the marker's position
    this.bounds.extend({ lat, lng });

    // Adjust the map's center and zoom to fit the bounds
    this.map.fitBounds(this.bounds);

    return marker;
  }

  setCenter(lat, lng) {
    this.map.setCenter({ lat, lng });
  }
}
